module.exports = __webpack_public_path__ + "static/media/Siren.62b53514.jpg";